import resolveAssetSource from 'react-native/Libraries/Image/resolveAssetSource';

export default resolveAssetSource;
